import { Text } from "@chakra-ui/react";
const PageNotFound = () => {
  return (
    <div>
      <Text>Page Not found</Text>
    </div>
  );
};
export default PageNotFound;
